module.exports = __webpack_public_path__ + "img/prize-04.26a55b3c.png";